import { useAppSelector } from 'index';

interface NavigationCounterLayoutOptions {
    isOpen: boolean;
    count: number;
    openLeft?: {
        en: number;
        other: number;
    };
}

export function useNavigationCounterLayout({
    isOpen,
    count,
    openLeft = { en: 120, other: 160 },
}: NavigationCounterLayoutOptions) {
    const language = useAppSelector((state) => state.global.language);
    const left = isOpen ? (language === 'en' ? openLeft.en : openLeft.other) : 35;
    const width = count > 99 ? 22 : count > 9 ? 16 : 12;

    return { left, width };
}
